import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { CommonTable } from 'gnos-tables'
import _ from 'lodash'

import CustomDate from '../../../../../../../../../../../components/CustomDate'
import Money from '../../../../../../../../../../../components/TableCell/components/Money'

import { LOCALE_PREFIX } from '../../../../Blocks/PaymentIndex/constants'

import './style.scss'

@injectIntl
export default class Table extends Component {
    static propTypes = {
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        selector: PropTypes.string.isRequired,
    }

    render() {
        const { id, data, intl, selector } = this.props

        if (_.isEmpty(data)) return null

        return (
            <div className={'payment-information-data-table'}>
                <CommonTable
                    key={`bisnode-scoring-common-table-${id}`}
                    id={`payment-information-common-table-${id}`}
                    columnsDefinition={[
                        {
                            accessor: 'startDate',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.date` }),
                            Cell: (value) => <CustomDate date={_.get(value, 'value.value', null)} precision={'days'} />,
                        },
                        {
                            accessor: `${selector}.paymentIndex.value`,
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.paymentIndex` }),
                        },
                        {
                            accessor: `${selector}.sector.value`,
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.paymentIndexSector` }),
                        },
                        {
                            accessor: `${selector}.totalAmount`,
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.totalAmountOfInvoices` }),
                            Cell: (value) => <Money value={_.get(value, 'value', {})} />,
                        },
                        {
                            accessor: `${selector}.invoiceCount`,
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.numberOfInvoices` }),
                        },
                        {
                            accessor: `${selector}.supplierCount`,
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.numberOfSuppliers` }),
                        },
                    ]}
                    staticData={{
                        _table: data,
                    }}
                />
            </div>
        )
    }
}
